import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDocument32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m19.656 2c.594 0 1.157.25 1.594.656l4.094 4.094c.437.438.656 1 .656 1.594v19.406c0 1.25-1 2.25-2.25 2.25h-15.5c-1.25 0-2.25-1-2.25-2.25v-23.5c0-1.25 1-2.25 2.25-2.25zm-1.656 2h-9.75a.269.269 0 0 0 -.25.25v23.5c0 .125.125.25.25.25h15.5c.125 0 .25-.125.25-.25v-17.75h-5c-.563 0-1-.438-1-1zm2 .219v3.781h3.781zm-10 18.781c0 .563.438 1 1 1h10c.563 0 1-.438 1-1 0-.563-.438-1-1-1h-10c-.563 0-1 .438-1 1zm0-4c0 .563.438 1 1 1h10c.563 0 1-.438 1-1 0-.563-.438-1-1-1h-10c-.563 0-1 .438-1 1zm0-4c0 .563.438 1 1 1h10c.563 0 1-.438 1-1 0-.563-.438-1-1-1h-10c-.563 0-1 .438-1 1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDocument32;
